import { useState, useEffect, useMemo } from "react";
import { Card, Row, Col, Switch, Spin } from "antd";
import { Line } from '@ant-design/plots';
import { useSelector, useDispatch } from "react-redux";

// Constants
import { dailyChart } from "../../constant"

// Components
import { FilterDays, FilterSelect } from "../../../../components/TableList";

//handler
import { calculateTotals, resultDailyData } from "../../handler"
import { dashboardHDLR } from "../../../../handlers"

import { REDUX as REDUX_UTIL } from "../../../../services/util";

// Style
import "../../index.css";

const { reduxStoreWrapper } = REDUX_UTIL;

const DailyStatistics = (props) => {
    const { items, selection, loading } = props;

    // const dispatch = useDispatch()

    const dailySummaries = useSelector(reduxStoreWrapper("dashboard.daily.summaries"));
    const company = useSelector(reduxStoreWrapper("company.byID"));

    const [showRequestedAmount, setShowRequestedAmount] = useState(true);
    const [showApplicants, setShowApplicants] = useState(true);
    const [showNewApplicants, setShowNewApplicants] = useState(true);
    const [showNetDisbursement, setShowNetDisbursement] = useState(true);
    const [showAdminFees, setShowAdminFees] = useState(true);
    const [showTotalApplications, setShowTotalApplications] = useState(true);
    const [selectedDays, setSelectedDays] = useState(30);
    const [valueComp, setValueComp] = useState(["ALL"]);
    const [dailyData, setDailyData] = useState(dailySummaries);
    const [isFilter, setIsFilter] = useState(false);
    // const [load, setLoad] = useState(false);

    useEffect(() => {
        if(dailySummaries.length) dashboardHDLR.applyFilters(dailySummaries, valueComp, selectedDays, setDailyData, setIsFilter);
    }, [dailySummaries, valueComp, selectedDays]);

    const onChangeSelect = (newValue) => {
        setIsFilter(true);
        setValueComp(newValue);
        // applyFilters(newValue, selectedDays);
    };

    const handleOptionDays = (value) => {
        setIsFilter(true);
        setSelectedDays(value);
        // applyFilters(valueComp, value);
    };

    // useEffect(() => {
    //   if (dailySummaries.length > 0) {
    //     setDailyData(dailySummaries);
    //     // setLoad(true);
    //   }
    // }, [dailySummaries]);

    //   const applyFilters = (companies, days) => {
    //     dashboardHDLR.applyFilters(dailySummaries, companies, days, setDailyData, setIsFilter);
    //   };

    const transformedData = resultDailyData(dailyData, showNetDisbursement, showAdminFees, showTotalApplications, showRequestedAmount, showApplicants, showNewApplicants)

    const totals = calculateTotals(dailyData)

    const config = dailyChart(transformedData)

    return (
        <Card className="card-shadow height-card">
            <div className="row-space header-card">
                <span className="title-card">Daily Statistics</span>
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <FilterDays 
                        defaultValue={selectedDays}
                        items={items}
                        handleChange={handleOptionDays}
                    />
                    <FilterSelect
                        selection={selection}
                        style={{ width: 170, height: 32, marginLeft: "4px" }}
                        selectedData={valueComp}
                        onChangeSelect={onChangeSelect}
                    />
                </div>
            </div>
            <Row style={{ marginLeft: "18px", marginBottom: "15px", marginTop: "5px" }}>
                <Col span={1}>
                    <Row>
                        <div className='color-round' style={{ backgroundColor: '#211572' }}></div>
                    </Row>
                    <Row style={{marginTop: "10px"}}>
                        <div className='color-round' style={{ backgroundColor: '#D10707' }}></div>
                    </Row>
                </Col>
                <Col span={5}>
                    <Row className="daily">Requested Amount</Row>
                    <Row style={{marginTop: "10px"}} className="daily">Total Applications</Row>
                </Col>
                <Col span={2}>
                    <Row className="daily">
                        <Switch
                            size="small"
                            defaultChecked
                            style={{ "--before-color": "white", "--bg-before-color": "#70A39F" }}
                            onChange={checked => setShowRequestedAmount(checked)}
                        />
                    </Row>
                    <Row style={{marginTop: "8px"}} className="daily">
                        <Switch  
                            size="small" 
                            defaultChecked
                            style={{ "--before-color": "white", "--bg-before-color": "#70A39F" }}
                            onChange={checked => setShowTotalApplications(checked)}
                        />
                    </Row>
                </Col>

                <Col span={1}>
                    <Row>
                        <div className='color-round' style={{ backgroundColor: '#821CB1' }}></div>
                    </Row>
                    <Row style={{marginTop: "10px"}}>
                        <div className='color-round' style={{ backgroundColor: '#FF0000' }}></div>
                    </Row>
                </Col>
                <Col span={6}>
                    <Row className="daily">Net Disbursement Amount</Row>
                    <Row style={{marginTop: "10px"}} className="daily">Total Applicants</Row>
                </Col>
                <Col span={2}>
                    <Row className="daily">
                        <Switch
                            size="small"
                            defaultChecked
                            style={{ "--before-color": "white", "--bg-before-color": "#70A39F" }}
                            onChange={checked => setShowNetDisbursement(checked)}
                        />
                    </Row>
                    <Row style={{marginTop: "8px"}} className="daily">
                        <Switch  
                            size="small" 
                            defaultChecked
                            style={{ "--before-color": "white", "--bg-before-color": "#70A39F" }}
                            onChange={checked => setShowApplicants(checked)}
                        />
                    </Row>
                </Col>

                <Col span={1}>
                    <Row>
                        <div className='color-round' style={{ backgroundColor: '#5454C5' }}></div>
                    </Row>
                    <Row style={{marginTop: "10px"}}>
                        <div className='color-round' style={{ backgroundColor: '#FFA800' }}></div>
                    </Row>
                </Col>
                <Col span={4}>
                    <Row className="daily">Admin Fees</Row>
                    <Row style={{marginTop: "10px"}} className="daily">New Applicants</Row>
                </Col>
                <Col span={2}>
                    <Row className="daily">
                        <Switch
                            size="small"
                            defaultChecked
                            style={{ "--before-color": "white", "--bg-before-color": "#70A39F" }}
                            onChange={checked => setShowAdminFees(checked)}
                        />
                    </Row>
                    <Row style={{marginTop: "8px"}} className="daily">
                        <Switch  
                            size="small" 
                            defaultChecked
                            style={{ "--before-color": "white", "--bg-before-color": "#70A39F" }}
                            onChange={checked => setShowNewApplicants(checked)}
                        />
                    </Row>
                </Col>
            </Row>
             
            {loading || Object.values(company).length === 0 || isFilter ? (
                <Spin style={{width: "95%", height: "350px", margin: "-6px 2px 0px 10px", display: "flex", alignItems: "center", justifyContent: "center"}}/>
            ) : (
                <div style={{ width: "95%", height: "350px", margin: "-6px 2px 0px 10px" }}>
                    <Line {...config} />
                </div>
            )}
            
            <Row style={{ display: "flex", justifyContent: "flex-start", padding: "0px 20px" }}>
                <Col span={8} className="daily">Total Requested Amount - RM{totals.total_pr_reqAmount}</Col>
                <Col span={10} className="daily">Total Net Disbursement Amount - RM{totals.total_pr_disbursed}</Col>
                <Col span={6} className="daily">Total Admin Fees - RM{totals.total_pr_fee}</Col>
            </Row>
            <Row style={{ display: "flex", justifyContent: "flex-start", padding: "10px 20px" }}>
                <Col span={8} className="daily">Total Applications - {totals.total_pr_request}</Col>
                <Col span={10} className="daily">Total Applicants - {totals.total_employee_applied}</Col>
                <Col span={6} className="daily">Total New Applicants - {totals.total_employee_first_applied}</Col>
            </Row>
        </Card>
    );
};

export default DailyStatistics;